import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../app/hooks";

const DashboardGreeting = () => {
  const { user } = useAppSelector((state) => state.user);
  const { t } = useTranslation();

  const getUserFirstName = () => {
    if (user) return `, ${user.firstName}!`;
    return "";
  };

  const getGreeting = (): string => {
    const currentHour = new Date().getHours();
    const firstName = getUserFirstName();
    let greeting = "";

    if (currentHour >= 5 && currentHour < 12) {
      greeting = t("common:greetingMorning");
    } else if (currentHour >= 12 && currentHour < 18) {
      greeting = t("common:greetingAfternoon");
    } else {
      greeting = t("common:greetingEvening");
    }

    return `${greeting}${firstName}`;
  };

  return (
    <>
      <Box padding="18px 8px 18px 8px" sx={{ flexShrink: 0 }}>
        <Typography
          variant="header"
          sx={{ fontSize: "32px", fontWeight: "600" }}
        >
          {getGreeting()}
        </Typography>
      </Box>
    </>
  );
};

export default DashboardGreeting;
